module.exports = __webpack_public_path__ + "img/beneficio-jubilacion.a8adca0a.svg";